<div class="ui-fluid ui-g-12 card">
    <!-- Report Roles, Permission -->
<div class="ui-g-12">

  <div class="description ui-g-12">
    {{ 'report.rolesPermissionReport' | translate }}
    <hr>
  </div>

  <div class="ui-g-12">
      <i class="fa fa-info-circle icon" style="float: right;" pTooltip="{{ 'report.info' | translate }}" tooltipPosition="left" (click)="openDialog('reportRolesPermission')"></i>
  </div>

  <!-- Filtri Report -->
  <div class="padd ui-g-12">

     <!-- Company -->
     <div class="ui-g-6 padd-top">
      <label>{{ 'common.company' | translate }}</label>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [options]="companies" [(ngModel)]="companySelectedRolesPermission"></p-dropdown>
    </div>

  </div>

    <div class="ui-g-12 text-center padd-top">
      <p-button
          styleClass="ui-button-info"
          label="{{ 'report.viewReport' | translate }}"
          (onClick)="reportRolesPermission()"
          >
        </p-button>
    </div>
</div>
</div>

<!-- Report -->
<div *ngIf="showReport" class="ui-g-12">
  <app-view-report 
  [showRolesPermission]="showReportRolesPermission" 
  [data]="report">
  </app-view-report>
</div>


// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-roles-permission/report-roles-permission.component.html